module.exports = __webpack_public_path__ + "static/media/linkedin.33fcc595.svg";